export default {"src":"/_next/static/media/0x6a07a792ab2965c72a5b8088d3a069a7ac3a993b.94d275b4.svg","height":126,"width":126,"blurWidth":0,"blurHeight":0};